import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { equipmentListFilterFields } from '@/features/equipment/equipmentListFilterFields';
import { ASSIGNMENT_MATRIX_FIELD_KEYS } from '@/features/equipment/query/assignment-matrix/type';
export const AssignmentRulesMatrixSearchSchema = z.object({
  ...dataGridSearchFields,
  sortColumn: z.enum(ASSIGNMENT_MATRIX_FIELD_KEYS).optional(),
  freeText: z.string().optional(),
  equipmentItemIdIn: equipmentListFilterFields.equipmentItemIdIn
});
export type AssignmentRulesMatrixSearch = z.infer<typeof AssignmentRulesMatrixSearchSchema>;